import type {
  AnnotationAuthorResource,
  ReadContentVersionAnnotationsDocument,
} from '../../v3/contentVersionAnnotations/types'
import type { ContentVersionAnnotation } from './types'

/**
 * Flattens the JSON:API document into view models, resolving each annotation's
 * author from the `included` users and ordering oldest-first so a pin's index maps
 * to its stable display number.
 */
export const flattenContentVersionAnnotations = (
  document: ReadContentVersionAnnotationsDocument
): ContentVersionAnnotation[] => {
  const authorsById = new Map<string, AnnotationAuthorResource>()
  for (const resource of document.included ?? []) {
    if (resource.type === 'user')
      authorsById.set(resource.id, resource as AnnotationAuthorResource)
  }

  return document.data
    .map((resource) => {
      const authorId = resource.relationships.author.data?.id
      const author = authorId ? authorsById.get(authorId) : undefined

      return {
        id: resource.id,
        x: resource.attributes.x,
        y: resource.attributes.y,
        layout: resource.attributes.layout,
        comment: resource.attributes.comment ?? '',
        createdAt: resource.attributes.created_at,
        authorName: author?.attributes.full_name ?? 'Unknown',
        resolved: resource.attributes.resolved,
      }
    })
    .sort((a, b) => a.createdAt.localeCompare(b.createdAt))
}
